// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-1YNRZ";
var _3 = "icon-3o1LJ";
var _4 = "text-3jcYh";
export { _1 as "__esModule", _2 as "button", _3 as "icon", _4 as "text" }
export default { "__esModule": _1, "button": _2, "icon": _3, "text": _4 }
